import { Link } from "react-router-dom";
import { fmtNGN, fmtUSD, img, tierFor, tierStyle } from "@/lib/api";
import { motion } from "framer-motion";

export default function ArtworkCard({ art, index = 0 }) {
  const tier = art.tier || tierFor(art.price_ngn);
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.03, 0.3) }}
    >
      <Link
        to={`/gallery/${art.id}`}
        data-testid={`artwork-card-${art.id}`}
        className="group block bg-card rounded-2xl overflow-hidden border border-border hover:shadow-[0_12px_40px_rgba(11,29,81,0.12)] transition-shadow"
      >
        <div className="aspect-[3/4] overflow-hidden bg-muted relative">
          <span className={`absolute top-2 left-2 z-10 text-[10px] font-bold px-2 py-0.5 rounded-full ${tierStyle(tier)}`} data-testid={`artwork-tier-${art.id}`}>{tier}</span>
          <img
            src={img(art.thumbnail)}
            alt={art.title}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-3">
          <p className="text-[10px] tracking-[0.15em] uppercase text-gold font-bold truncate">{art.category}</p>
          <h3 className="font-heading font-semibold text-sm leading-tight truncate mt-0.5">{art.title}</h3>
          <p className="text-xs text-muted-foreground truncate">{art.artist}</p>
          <div className="mt-2 flex items-baseline justify-between">
            <span className="font-bold text-sm">{fmtNGN(art.price_ngn)}</span>
            <span className="text-xs text-muted-foreground">{fmtUSD(art.price_usd)}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
